import React, { forwardRef, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import styles from './ProductCardContainer.module.scss';

type PropsType = Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> & {
  className?: string;
  linkTo?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

function ProductCardContainer(
  { className, children, linkTo, onClick, ...props }: PropsType,
  ref
): JSX.Element {
  return (
    <div
      className={classNames(styles.container, className)}
      ref={ref}
      {...props}
    >
      {linkTo && <Link to={linkTo} className={styles.link} onClick={onClick} />}
      {children}
    </div>
  );
}

export default forwardRef(ProductCardContainer);
